const GUEST_PUBLIC_CONSENT_KEY = 'guest_public_images_consent';
export const GUEST_CONSENT_REQUIRED_EVENT = 'guest-consent-required';

export function hasGuestPublicConsent(): boolean {
  try {
    return localStorage.getItem(GUEST_PUBLIC_CONSENT_KEY) === 'true';
  } catch {
    return false;
  }
}

export function setGuestPublicConsent(): void {
  try {
    localStorage.setItem(GUEST_PUBLIC_CONSENT_KEY, 'true');
  } catch {
    // ignore storage errors
  }
}

export function requestGuestPublicConsent(): void {
  window.dispatchEvent(new Event(GUEST_CONSENT_REQUIRED_EVENT));
}
